import { Result } from 'domain/types';
import UpdateLayoutClient from 'use-case/layout/update/updateLayoutClient';
import UpdateLayoutCriteria from 'use-case/layout/update/updateLayoutCriteria';
import BasicEntity from 'domain/entity/basicEntity';

export type UpdateLayoutResult = Result<BasicEntity>;
export type UpdateLayout = (criteria: UpdateLayoutCriteria) => Promise<UpdateLayoutResult>;

const updateLayoutUseCase = (updateLayoutClient: UpdateLayoutClient): UpdateLayout => (
    criteria: UpdateLayoutCriteria
): Promise<UpdateLayoutResult> => updateLayoutClient(criteria);

export default updateLayoutUseCase;
